import { Avatar } from '@mui/material';
import type { User } from '~/generated/graphql';

interface UserAvatarProps {
  user: Pick<User, 'name'>;
}

const userColor = (user: Pick<User, 'name'>) => {
  const hue =
    user.name.split('').reduce((hash, char) => char.charCodeAt(0) + (hash << 5) - hash, 0) % 360;

  return `hsl(${hue}, 55%, 45%)`;
};

export const UserAvatar = ({ user }: UserAvatarProps) => {
  return (
    <Avatar
      alt={user.name}
      sx={{
        width: (theme) => theme.spacing(3),
        height: (theme) => theme.spacing(3),
        border: '1px solid white',
        backgroundColor: userColor(user),
      }}
    >
      {user.name.trim()[0].toUpperCase()}
    </Avatar>
  );
};
